(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();

      this.ACTIVE_CLASS = 'announcement-bar--active';

      this.announcementBlocks = this.querySelectorAll('[data-announcement-block]');
      this.dropdown = this.querySelector('[data-announcement-dropdown]');
      this.closeButton = this.querySelector('[data-announcement-close]');
      this.overlay = this.querySelector('[data-announcement-overlay]');
      this.AUTO_ROTATE_INTERVAL = 4000;
      this.activeIndex = 0;
      this.isPaused = false;
      this.autoRotateRef = null;
      this.touchActive = false;
      this.mobileMedia = window.matchMedia('(max-width: 749px)');
    }

    connectedCallback() {
      this.announcementBlocks.forEach((block) => block.addEventListener('click', () => this.openDropdown()));
      this.closeButton.addEventListener('click', () => this.closeDropdown());
      this.overlay.addEventListener('click', () => this.closeDropdown());

      if (this.mobileMedia.matches) {
        this.showAnnouncement(this.activeIndex);
        this.setupAutoRotate();

        this.addEventListener('touchstart', this.handleTouchStart.bind(this));
        this.addEventListener('touchend', this.handleTouchEnd.bind(this));

        window.addEventListener('resize', this.handleResize.bind(this));
      }
    }

    setupAutoRotate() {
      this.clearAutoRotate();

      if (this.isPaused || this.announcementBlocks.length <= 1) return;

      this.autoRotateRef = setInterval(() => {
        this.activeIndex = (this.activeIndex + 1) % this.announcementBlocks.length;
        this.showAnnouncement(this.activeIndex);
      }, this.AUTO_ROTATE_INTERVAL);
    }

    clearAutoRotate() {
      if (this.autoRotateRef) {
        clearInterval(this.autoRotateRef);

        this.autoRotateRef = null;
      }
    }

    handleResize() {
      if (this.mobileMedia.matches) {
        this.setupAutoRotate();
        this.showAnnouncement(this.activeIndex);
      } else {
        this.clearAutoRotate();
        this.resetTransforms();
      }
    }

    handleTouchStart() {
      if (this.mobileMedia.matches) {
        this.isPaused = true;
        this.touchActive = true;
        this.clearAutoRotate();
      }
    }

    handleTouchEnd() {
      if (this.mobileMedia.matches && this.touchActive) {
        this.isPaused = false;
        this.touchActive = false;
        this.setupAutoRotate();
      }
    }

    showAnnouncement(index) {
      this.announcementBlocks.forEach((element) => {
        element.style.transition = 'transform 0.5s';
        element.style.transform = `translateX(${-index * 100}%)`;
      });
    }

    resetTransforms() {
      this.announcementBlocks.forEach((el) => {
        el.style.transition = '';
        el.style.transform = '';
      });
    }

    openDropdown() {
      this.classList.add(this.ACTIVE_CLASS);

      document.body.classList.add('blur');
    }

    closeDropdown() {
      this.classList.remove('announcement-bar--active');

      document.body.classList.remove('blur');
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"] && !Shopify.designMode) return;
  try {
    
  class CartSummary extends HTMLElement {
    constructor() {
      super();

      this.toggleButton = this.querySelector('.js-summary-toggle');
      this.content = this.querySelector('.js-summary-content');

      if (this.toggleButton && this.content) {
        this.toggleButton.addEventListener('click', this.toggle.bind(this));
      }

      this.initDesktopState();
      window.addEventListener('resize', this.initDesktopState.bind(this));
    }

    initDesktopState() {
      if (window.innerWidth >= 750) {
        this.content.style.maxHeight = 'none';
        this.content.classList.add('open');
      } else {
        if (!this.content.classList.contains('open')) {
          this.content.style.maxHeight = '0px';
        }
      }
    }

    toggle() {
      if (window.innerWidth >= 750) return;

      if (this.content.classList.contains('open')) {
        this.close();
      } else {
        this.open();
      }
    }

    open() {
      this.content.classList.add('open');
      this.content.style.maxHeight = this.content.scrollHeight + 'px';
      this.classList.add('active');

      setTimeout(() => {
        if (this.content.classList.contains('open')) {
          this.content.style.maxHeight = 'none';
        }
      }, 350);
    }

    close() {
      this.content.style.maxHeight = this.content.scrollHeight + 'px';

      requestAnimationFrame(() => {
        this.content.style.maxHeight = '0px';
      });

      this.content.classList.remove('open');
      this.classList.remove('active');
    }
  }

  if (!customElements.get('cart-summary')) {
    customElements.define('cart-summary', CartSummary);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-blocks"] && !Shopify.designMode) return;
  try {
    
  class ImageGrid extends HTMLElement {
    constructor() {
      super();
      this.loadMoreButton = this.querySelector('.js--load-more-button');
      this.blocks = this.querySelectorAll('.js--block');
      this.loadMoreButton.addEventListener('click', () => this.loadMore());
    }

    loadMore() {
      const visibleBlocks = this.querySelectorAll('.js--block:not(.hidden-mobile)');
      const visibleIntriment = visibleBlocks.length % 5 === 0 ? 3 : 2;

      for (let i = visibleBlocks.length; i < visibleBlocks.length + visibleIntriment; i++) {
        if (this.blocks[i]) {
          this.blocks[i].classList.remove('hidden-mobile');
        }
      }

      if (this.blocks.length <= this.querySelectorAll('.js--block:not(.hidden-mobile)').length) {
        this.loadMoreButton.classList.add('hidden');
      }
    }
  }

  customElements.define('image-grid', ImageGrid);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-card-carousel"] && !Shopify.designMode) return;
  try {
    
  class CardList extends HTMLElement {
    constructor() {
      super();
      this.loadMoreButton = this.querySelector('.content-card-carousel__load-more');

      if (this.loadMoreButton) {
        this.loadMoreButton.addEventListener('click', this.handleLoadMore.bind(this));
      }
    }

    handleLoadMore() {
      const hiddenItems = this.querySelectorAll('.content-card-carousel__item[style*="display:none"]');

      hiddenItems.forEach((item) => {
        item.style.removeProperty('display');
      });

      requestAnimationFrame(() => {
        hiddenItems.forEach((item) => {
          item.querySelectorAll('product-gallery').forEach((gallery) => {
            if (!gallery.splide) return;

            gallery.splide.refresh();
            gallery.splide.go(0, true);
          });
        });
      });

      this.loadMoreButton.style.display = 'none';
      this.loadMoreButton.setAttribute('aria-hidden', 'true');
    }
  }

  if (!customElements.get('card-list')) {
    customElements.define('card-list', CardList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["features-blocks"] && !Shopify.designMode) return;
  try {
    
  class FeaturesBlocks extends HTMLElement {
    constructor() {
      super();
      this.desktopCards = this.querySelectorAll('.card');
      this.mobileSlidesList = this.querySelector('.js--features-carousel-mobile .splide__list');
    }

    connectedCallback() {
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.waitForSplide().then(() => {
              this.initMobileCarousel();
            });
            observer.disconnect();
          }
        });
      });
      observer.observe(this);
    }

    waitForSplide() {
      return new Promise((resolve) => {
        if (window.Splide) {
          resolve();
          return;
        }

        const interval = setInterval(() => {
          if (window.Splide) {
            clearInterval(interval);
            resolve();
          }
        }, 50);
      });
    }

    initMobileCarousel() {
      this.desktopCards.forEach((card) => {
        const slide = document.createElement('li');
        slide.classList.add('splide__slide');
        slide.appendChild(card.cloneNode(true));
        this.mobileSlidesList.appendChild(slide);
      });

      const splideEl = this.querySelector('.js--features-carousel-mobile');
      this.mobileCarousel = new Splide(splideEl, {
        perPage: 1,
        perMove: 1,
        arrows: true,
        pagination: false,
        drag: true,
        speed: 600,
        gap: 16,
        padding: { left: 16, right: 16 },
      });

      const navigation = this.mobileCarousel.root.querySelector('.carousel-navigation');
      const bar = navigation.querySelector('.carousel-navigation-progress-bar');

      const updateProgress = () => {
        if (!bar) return;
        const total = this.mobileCarousel.length;
        const perPage = this.mobileCarousel.options.perPage;
        const currentIndex = this.mobileCarousel.index;
        const covered = Math.min(currentIndex + perPage, total);
        const progress = total === 0 ? 0 : covered / total;
        bar.style.width = progress * 100 + '%';
      };

      this.mobileCarousel.on('overflow', function (isOverflow) {
        this.mobileCarouseloptions = {
          drag: isOverflow,
        };

        if (navigation) {
          navigation.style.display = isOverflow ? 'flex' : 'none';
        }
      });

      this.mobileCarousel.on('mounted move', updateProgress);
      splideEl.splideInstance = this.mobileCarousel;

      this.mobileCarousel.mount();
      setTimeout(() => {
        this.classList.add('mobile-carousel-loaded');
      }, 100);
    }
  }
  customElements.define('features-blocks', FeaturesBlocks);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('scroll', () => {
    let transparentHeader = document.querySelector('.transparent-header');
    if (transparentHeader) {
      if (window.scrollY > 0) {
        transparentHeader.classList.add('scrolled');
      } else {
        transparentHeader.classList.remove('scrolled');
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-banner"] && !Shopify.designMode) return;
  try {
    
  function initMediaBannerSplide(section) {
    const splideElements = document.querySelectorAll('.media-banner .splide');

    splideElements.forEach(function (splideEl) {
      if (splideEl.splideInstance) {
        splideEl.splideInstance.destroy();
      }

      const splide = new Splide(splideEl, {
        type: 'fade',
        perPage: 1,
        arrows: true,
        pagination: false,
        drag: true,
        waitForTransition: false,
        lazyLoad: 'sequential'
      });

      splide.on('mounted', function () {
        let current = document.querySelector('.current-slide');
        let total = document.querySelector('.total-slides');

        function updateFraction() {
          current.textContent = ('0' + (splide.index + 1)).slice(-2);
          total.textContent = ('0' + splide.length).slice(-2);
        }

        updateFraction();
        splide.on('move', updateFraction);
      });

      splideEl.splideInstance = splide;

      splide.mount();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMediaBannerSplide();
  });

  document.addEventListener('shopify:section:load', function () {
    initMediaBannerSplide();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-sticky-header"] && !Shopify.designMode) return;
  try {
    
  class PDPStickyHeader extends HTMLElement {
    constructor() {
      super();
      this._onTrackScroll = this._onTrackScroll.bind(this);
      this._toggleAnchors = this._toggleAnchors.bind(this);
      this._closeAnchorsOnOutside = this._closeAnchorsOnOutside.bind(this);
      this._closeOnAnchorClick = this._closeOnAnchorClick.bind(this);
    }

    connectedCallback() {
      this.productSection = document.querySelector('.product-section');
      this.anchorLabelBtn = this.querySelector('.pdp-sticky-header__anchors__label');
      this.anchorLabelText = this.anchorLabelBtn.querySelector('.pdp-sticky-header__anchors__label-text');
      this.anchorList = this.querySelector('.pdp-anchors-list');
      this.anchorLinks = [...this.querySelectorAll('.pdp-sticky-header__anchor')];

      this.sections = this.anchorLinks.map((link) => document.querySelector(link.getAttribute('href'))).filter(Boolean);

      this._initMobileDropdown();
      window.addEventListener('scroll', this._onTrackScroll);
      window.addEventListener('resize', this._onResize.bind(this));
      this._onTrackScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onTrackScroll);
      if (this.anchorLabelBtn) {
        this.anchorLabelBtn.removeEventListener('click', this._toggleAnchors);
        document.removeEventListener('click', this._closeAnchorsOnOutside);
      }
    }

    _setActive(link) {
      this.anchorLinks.forEach((a) => a.classList.remove('active'));
      link.classList.add('active');

      if (this.anchorLabelText) {
        this.anchorLabelText.textContent = link.textContent.trim();
      }
    }

    _onResize() {
      this._initMobileDropdown();
      this._onTrackScroll();
    }

    _initMobileDropdown() {
      const isMobile = window.innerWidth <= 989;
      if (!this.anchorLabelBtn || !this.anchorList) return;

      const anchorLinks = this.anchorList.querySelectorAll('a[href^="#"]');

      if (isMobile) {
        this.anchorLabelBtn.addEventListener('click', this._toggleAnchors);
        document.addEventListener('click', this._closeAnchorsOnOutside);
        anchorLinks.forEach((link) => link.addEventListener('click', this._closeOnAnchorClick));
      } else {
        this.anchorList.classList.remove('is-open');
        this.anchorLabelBtn.classList.remove('is-open');
        this.anchorLabelBtn.removeEventListener('click', this._toggleAnchors);
        document.removeEventListener('click', this._closeAnchorsOnOutside);
        anchorLinks.forEach((link) => link.removeEventListener('click', this._closeOnAnchorClick));
      }
    }

    _onTrackScroll() {
      if (!this.productSection) return;

      const rect = this.productSection.getBoundingClientRect();
      this.classList.toggle('is-sticky', rect.top <= -rect.height);

      this._updateActiveByScroll();
    }

    _updateActiveByScroll() {
      const offset = 80;
      let current = null;

      this.sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        if (rect.top <= offset && rect.bottom > offset) {
          current = section;
        }
      });

      if (!current) return;

      const activeLink = this.anchorLinks.find((link) => link.getAttribute('href') === `#${current.id}`);

      if (activeLink && !activeLink.classList.contains('is-active')) {
        this._setActive(activeLink);
      }
    }

    _toggleAnchors(e) {
      e.stopPropagation();
      this.anchorList.classList.toggle('is-open');
      this.anchorLabelBtn.classList.toggle('is-open');
    }

    _closeAnchorsOnOutside(e) {
      if (!this.contains(e.target)) {
        this.anchorList.classList.remove('is-open');
        this.anchorLabelBtn.classList.remove('is-open');
      }
    }

    _closeOnAnchorClick() {
      this.anchorList.classList.remove('is-open');
      this.anchorLabelBtn.classList.remove('is-open');
    }

    closeAnchors() {
      this._closeOnAnchorClick();
    }
  }

  customElements.define('pdp-sticky-header', PDPStickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-comparison-table"] && !Shopify.designMode) return;
  try {
    
  class ComparisonTable extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.wrapper = this.querySelector('.product-comparison-table__wrapper');
      this.controlsWrapper = this.querySelector('.comparison-scroll-controls');
      this.btnLeft = this.querySelector('.scroll-left');
      this.btnRight = this.querySelector('.scroll-right');
      this.progressBar = this.querySelector('.scroll-progress-bar');

      if (!this.wrapper) return;

      this.scrollAmount = 250;

      this.initScrollButtons();
      this.initDragScroll();
      this.initEvents();

      this.updateVisibility();
      this.updateProgress();
      this.updateButtons();
      this.updateColumnVisibility();
    }

    initEvents() {
      this.wrapper.addEventListener('scroll', () => {
        this.updateProgress();
        this.updateButtons();
        this.updateColumnVisibility();
      });

      window.addEventListener('resize', () => {
        this.updateVisibility();
        this.updateProgress();
        this.updateButtons();
        this.updateColumnVisibility();
      });
    }

    initScrollButtons() {
      if (!this.btnLeft || !this.btnRight) return;

      this.btnLeft.addEventListener('click', () => {
        this.wrapper.scrollBy({ left: -this.scrollAmount, behavior: 'smooth' });
      });

      this.btnRight.addEventListener('click', () => {
        this.wrapper.scrollBy({ left: this.scrollAmount, behavior: 'smooth' });
      });
    }

    updateVisibility() {
      const hasScroll = this.wrapper.scrollWidth > this.wrapper.clientWidth;

      if (hasScroll) {
        this.controlsWrapper?.style.setProperty('display', 'flex');
      } else {
        this.controlsWrapper?.style.setProperty('display', 'none');
      }

      this.wrapper.classList.toggle('has-scroll', hasScroll);
    }

    updateProgress() {
      if (!this.progressBar) return;

      const visible = this.wrapper.clientWidth;
      const total = this.wrapper.scrollWidth;
      const scrolled = this.wrapper.scrollLeft;

      const progress = (scrolled + visible) / total;
      this.progressBar.style.width = `${progress * 100}%`;
    }

    updateButtons() {
      if (!this.btnLeft || !this.btnRight) return;

      const maxScrollLeft = this.wrapper.scrollWidth - this.wrapper.clientWidth;

      if (this.wrapper.scrollLeft <= 0) {
        this.btnLeft.disabled = true;
        this.btnLeft.classList.add('disabled');
      } else {
        this.btnLeft.disabled = false;
        this.btnLeft.classList.remove('disabled');
      }

      if (this.wrapper.scrollLeft >= maxScrollLeft - 1) {
        this.btnRight.disabled = true;
        this.btnRight.classList.add('disabled');
      } else {
        this.btnRight.disabled = false;
        this.btnRight.classList.remove('disabled');
      }
    }

    initDragScroll() {
      let isDown = false;
      let startX;
      let scrollLeft;

      this.wrapper.addEventListener('mousedown', (e) => {
        isDown = true;
        this.wrapper.classList.add('dragging');
        startX = e.pageX - this.wrapper.offsetLeft;
        scrollLeft = this.wrapper.scrollLeft;
      });

      this.wrapper.addEventListener('mouseleave', () => {
        isDown = false;
        this.wrapper.classList.remove('dragging');
      });

      this.wrapper.addEventListener('mouseup', () => {
        isDown = false;
        this.wrapper.classList.remove('dragging');
      });

      this.wrapper.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();

        const x = e.pageX - this.wrapper.offsetLeft;
        const walk = (x - startX) * 1.2;
        this.wrapper.scrollLeft = scrollLeft - walk;
      });

      this.wrapper.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        scrollLeft = this.wrapper.scrollLeft;
      });

      this.wrapper.addEventListener('touchmove', (e) => {
        const x = e.touches[0].clientX;
        const walk = (x - startX) * 1.2;
        this.wrapper.scrollLeft = scrollLeft - walk;
      });
    }

    updateColumnVisibility() {
      const headCols = this.querySelectorAll('.product-comparison-table__head .comparison-table-col');
      const valueRows = this.querySelectorAll('.comparison-table-row');

      if (window.innerWidth > 450) {
        headCols.forEach((col) => col.classList.remove('col-visible'));
        valueRows.forEach((row) => {
          row.querySelectorAll('.comparison-table-col').forEach((col) => col.classList.remove('col-visible'));
        });
        return;
      }

      const wrapperRect = this.wrapper.getBoundingClientRect();

      let activeIndex = null;

      const scrolledToEnd = this.wrapper.scrollLeft + this.wrapper.clientWidth >= this.wrapper.scrollWidth - 1;

      if (scrolledToEnd) {
        activeIndex = headCols.length - 1;
      } else {
        headCols.forEach((col, index) => {
          const rect = col.getBoundingClientRect();
          const fullyVisible = rect.left >= wrapperRect.left && rect.right <= wrapperRect.right;

          if (fullyVisible && activeIndex === null) {
            activeIndex = index;
          }
        });

        if (activeIndex === null) {
          let minOffset = Infinity;

          headCols.forEach((col, index) => {
            const rect = col.getBoundingClientRect();
            const offset = Math.abs(rect.left - wrapperRect.left);

            if (offset < minOffset) {
              minOffset = offset;
              activeIndex = index;
            }
          });
        }
      }

      headCols.forEach((col) => col.classList.remove('col-visible'));
      valueRows.forEach((row) => {
        row.querySelectorAll('.comparison-table-col').forEach((col) => col.classList.remove('col-visible'));
      });

      if (activeIndex !== null) {
        if (headCols[activeIndex]) headCols[activeIndex].classList.add('col-visible');

        valueRows.forEach((row) => {
          const cols = row.querySelectorAll('.comparison-table-col');
          if (cols[activeIndex]) cols[activeIndex].classList.add('col-visible');
        });
      }
    }
  }

  customElements.define('comparison-table', ComparisonTable);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-block"] && !Shopify.designMode) return;
  try {
    
  function initUgcSplide() {
    const splideElements = document.querySelectorAll('.js-ugc-splide');

    splideElements.forEach(function (splideEl) {
      if (splideEl.splideInstance) {
        splideEl.splideInstance.destroy();
      }

      const desktop = parseInt(splideEl.dataset.desktop) || 5;
      const tablet = parseInt(splideEl.dataset.tablet) || 3;
      const mobile = parseInt(splideEl.dataset.mobile) || 1;

      let splideOptions = {
        perPage: desktop,
        perMove: 1,
        arrows: true,
        pagination: false,
        drag: true,
        speed: 600,
        gap: 20,
        breakpoints: {
          990: {
            perPage: tablet,
            gap: 16,
          },
          749: {
            perPage: mobile,
            trimSpace: false,
            gap: 16,
            padding: {
              left: 40,
              right: 40,
            },
          },
        },
      };

      const splide = new Splide(splideEl, splideOptions);

      const navigation = splide.root.querySelector('.carousel-navigation');
      const bar = navigation.querySelector('.carousel-navigation-progress-bar');

      function updateProgress() {
        if (!bar) return;

        const total = splide.length;
        const perPage = splide.options.perPage;
        const currentIndex = Math.floor(splide.index);

        const covered = Math.min(currentIndex + perPage, total);
        const progress = total === 0 ? 0 : covered / total;

        bar.style.width = progress * 100 + '%';
      }

      splide.on('overflow', function (isOverflow) {
        splide.options = {
          drag: isOverflow,
        };

        if (navigation) {
          navigation.style.display = isOverflow ? 'flex' : 'none';
        }
      });

      splide.on('mounted move', updateProgress);

      splideEl.splideInstance = splide;
      splide.mount();
    });
  }

  document.addEventListener('DOMContentLoaded', initUgcSplide);
  document.addEventListener('shopify:section:load', initUgcSplide);

  } catch(e) { console.error(e); }
})();
})();
